import React, { useCallback } from 'react';
import GenericModal, { IGenericModalProps } from './../GenericModal/GenericModal';
import { modalsActionsClose } from 'store/modules/ModalsActions';
import { ModalsActionsClose } from './../../store/modules/ModalsActionTypes';
import { IModalProps } from './../../store/modules/ModalsReducer';
import { connect, useDispatch } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { Grid, Button } from '@material-ui/core';
import { useStyles, useFooterStyles } from './styles'

export interface IConfirmModalGenericProps extends IGenericModalProps {
  contentText: string | React.ReactNode,
  title: string,
  key: string,
  confirmLabel?: string,
  confirmCallback: Function,
  cancelLabel?: string,
  cancelCallback?: Function
}

export interface IConfirmModal extends IModalProps {
  genericProps: IConfirmModalGenericProps,
  modalsActionsClose: (key: string) => ModalsActionsClose
}

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
  modalsActionsClose
}, dispatch);

const AssembleiaDocsModal = ({ genericProps }: IConfirmModal) => {

  const classes = useStyles();
  const footerClasses = useFooterStyles();
  const dispatchAction = useDispatch();

  const toClose = useCallback((): void => {
    if (genericProps && genericProps.key) {
      dispatchAction(modalsActionsClose(genericProps.key));
    }
  }, [genericProps, dispatchAction])

  const toCancel = useCallback(() => {
    if (typeof genericProps.cancelCallback === 'function') {
      genericProps.cancelCallback();
    }
    toClose();
  }, [toClose, genericProps]);

  const toConfirm = useCallback(() => {
    genericProps.confirmCallback();
    toClose();
  }, [toClose, genericProps]);

  return (
    <GenericModal
      title={ genericProps.title }
      content={(
        <Grid container className={ classes.root }>
          <Grid item xs={12} sm={12} md={12} lg={12} className={ classes.content }>
            { genericProps.contentText }
          </Grid>
        </Grid>
      )}
      genericProps={{
        maxWidth: 'sm',
        onClose: toClose,
        footerContent: (
          <Grid container>
            <Grid item xs={12} sm={6} className={ footerClasses.leftContent }>
              <Button
                variant="outlined"
                color="primary"
                onClick={ () => toCancel() }>
                {genericProps?.cancelLabel || 'Cancelar'}
              </Button>
            </Grid>
            <Grid item xs={12} sm={6} className={ footerClasses.rightContent }>
              <Button
                variant="contained"
                color="primary"
                onClick={ () => toConfirm() }>
                {genericProps?.confirmLabel || 'Sim'}
              </Button>
            </Grid>
          </Grid>
        )
      }}
    />
  )
}

export default connect(null, mapDispatchToProps)(AssembleiaDocsModal);
